import { Role } from '@/domain/Role';
import { z } from 'zod';

export const userRoleSchema = z.object({
  role: z.nativeEnum(Role, {
    message: 'Please select a role',
  }),
});

export type UserRoleFormValues = z.infer<typeof userRoleSchema>;
